import {
	BankToAdd,
	TransactionDataValidationStatus,
	BankError,
} from '#modules/Bank/Bank.types'

export type StartFetchBankSessionsTransactionsAction = {
	type: 'transactionClientApp/fetchBankSessionsTransactions'
	deselectedAccountIds: string[]
	calculationReferenceDate?: Date
}
type FetchBankSessionsTransactionsSucceededAction = {
	type: 'transactionClientApp/fetchBankSessionsTransactionsSucceeded'
	shouldClearBudgetAndDebtData: boolean
	banksToAdd: BankToAdd[]
	TransactionDataValidation: TransactionDataValidationStatus
}

type FetchBankSessionsTransactionsFailedAction = {
	type: 'transactionClientApp/fetchBankSessionsTransactionsFailed'
	fetchTransactionsError: BankError
}
type ReopenSessionAction = {
	type: 'transactionClientApp/reopenConsumerDataPullSession'
}
type ReopenSessionSucceededAction = {
	type: 'transactionClientApp/reopenConsumerDataPullSessionSucceeded'
}
type ReopenSessionFailedAction = {
	type: 'transactionClientApp/reopenConsumerDataPullSessionFailed'
	reopenSessionError: BankError
}
type FetchBankSessionsTransactionsClearErrorsAction = {
	type: 'transactionClientApp/fetchBankSessionsTransactionsClearErrors'
}

export type FetchBankSessionsTransactionsAction =
	| StartFetchBankSessionsTransactionsAction
	| FetchBankSessionsTransactionsSucceededAction
	| FetchBankSessionsTransactionsFailedAction
	| ReopenSessionAction
	| ReopenSessionSucceededAction
	| ReopenSessionFailedAction
	| FetchBankSessionsTransactionsClearErrorsAction

export function fetchBankSessionsTransactions(
	deselectedAccountIds: string[],
	calculationReferenceDate?: Date,
): StartFetchBankSessionsTransactionsAction {
	return {
		type: 'transactionClientApp/fetchBankSessionsTransactions',
		deselectedAccountIds,
		calculationReferenceDate,
	}
}

export function fetchBankSessionsTransactionsSucceeded(
	shouldClearBudgetAndDebtData: boolean,
	missingBanks: BankToAdd[],
	TransactionDataValidation: TransactionDataValidationStatus,
): FetchBankSessionsTransactionsSucceededAction {
	return {
		type: 'transactionClientApp/fetchBankSessionsTransactionsSucceeded',
		shouldClearBudgetAndDebtData,
		banksToAdd: missingBanks,
		TransactionDataValidation: TransactionDataValidation,
	}
}

export function fetchBankSessionsTransactionsFailed(
	fetchTransactionsError: BankError,
): FetchBankSessionsTransactionsFailedAction {
	return {
		type: 'transactionClientApp/fetchBankSessionsTransactionsFailed',
		fetchTransactionsError,
	}
}

export function reopenConsumerDataPullSession(): ReopenSessionAction {
	return {
		type: 'transactionClientApp/reopenConsumerDataPullSession',
	}
}

export function reopenConsumerDataPullSessionSucceeded(): ReopenSessionSucceededAction {
	return {
		type: 'transactionClientApp/reopenConsumerDataPullSessionSucceeded',
	}
}

export function reopenConsumerDataPullSessionFailed(
	reopenSessionError: BankError,
): ReopenSessionFailedAction {
	return {
		type: 'transactionClientApp/reopenConsumerDataPullSessionFailed',
		reopenSessionError,
	}
}

export function clearFetchBankSessionsTransactionsErrors(): FetchBankSessionsTransactionsAction {
	return {
		type: 'transactionClientApp/fetchBankSessionsTransactionsClearErrors',
	}
}
